import { useState, useCallback } from 'react';

const KERNEL_RESPONSES = [
  '[VERDICT] BLOCKED\n[REASON] Violation of Policy 82.1',
  '[VERDICT] APPROVED\n[SCOPE] Sandbox only, 60s TTL',
  '[VERDICT] QUARANTINED\n[REASON] Unrecognized DID pattern',
  '[VERDICT] ESCALATED\n[NOTE] Requires human override',
];

export function KernelTerminal() {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState<string[]>([
    '> kernel online',
    '> awaiting operator input...',
  ]);
  const [responseIndex, setResponseIndex] = useState(0);

  const handleSubmit = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key !== 'Enter' || !input.trim()) return;

      const command = input.trim();
      const response = KERNEL_RESPONSES[responseIndex % KERNEL_RESPONSES.length];

      setOutput((prev) => [
        ...prev,
        `> ${command}`,
        ...response.split('\n'),
        '',
      ]);
      setResponseIndex((i) => i + 1);
      setInput('');
    },
    [input, responseIndex],
  );

  return (
    <div className="social-box rounded overflow-hidden">
      <div
        className="box-header font-mono"
        style={{ background: '#000', color: '#00ff00' }}
      >
        Symbiosis Kernel v9.2
      </div>
      <div className="kernel-terminal" style={{ height: 80, overflowY: 'auto' }}>
        <div>
          {output.map((line, i) => (
            <div key={i} style={{ whiteSpace: 'pre-wrap', lineHeight: 1.4 }}>
              {line}
            </div>
          ))}
        </div>
        <input
          className="kernel-input"
          type="text"
          placeholder="sudo override..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleSubmit}
        />
      </div>
    </div>
  );
}
